
interface CardCornerLabelProps {
    text: string;
    color?: string;
    bgColor?: string;
}


export default function CardCornerLabel({ text, color, bgColor }: CardCornerLabelProps) {
    return (
        <div
            style={{
                position: 'absolute',
                top: '-1px',
                left: '-1px',
                width: 0,
                height: 0,
                borderTop: `60px solid ${bgColor || '#cce681'}`,
                borderRight: '60px solid transparent',
                borderTopLeftRadius: '12px',
                zIndex: 2,
                pointerEvents: 'none',
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: '-50px',
                    left: 5,
                    color: color || 'black',
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    transform: 'rotate(-45deg)',
                    pointerEvents: 'none',
                }}
            >
                {text}
            </span>
        </div>
    );
}
